import styled from "styled-components";

export const Img = styled.img`
  width: 40px;
  height: 38px;
`;
